<template>
  <div class="container-main yellowBackground">
          <!-- <AccessibilityOptions /> -->
      <Hero />
      <section>
        <div class="section-hero sec-one"></div>
        <div class="container-section" id="SuitableForRoute">
          <SuitableForRoute  />
        </div>
      </section>

      <section v-intersection.once="onIntersection" :class="visibleClassFive">
        <div class="container-quote-banner">
            <blockquote class="quoteBeforeAfter">Successful claimants on this route will be able to analyse their influence and draw on a range of illustrations in a relatively spontaneous way, in conversation with similarly experienced reviewers.</blockquote>
        </div>
      </section>

      <section  v-intersection.once="onIntersection" :class="visibleClassFive">
        <div class="section-hero sec-two"></div>
        <div class="container-section" id="HowRecognisedViaDialogue">
          <HowRecognisedViaDialogue/>
        </div>
      </section>

      <section  v-intersection.once="onIntersectionTwo" :class="visibleClassSix">
        <div class="container-quote-banner">
            <blockquote class="quoteBeforeAfter">Importantly, the onus is on the reviewers to ensure all dimensions are explored, so they will interject regularly, to satisfy themselves that every area is fully met.
            </blockquote>
        </div>
      </section>

      <section  v-intersection.once="onIntersection" :class="visibleClassSix">
        <div class="section-hero sec-three" ></div>
        <div class="container-section" id="MentorDuties">
          <MentorDuties />
        </div>
      </section>

      <section  v-intersection.once="onIntersectionThree" :class="visibleClassSeven">
        <div class="container-quote-banner">
            <blockquote class="quoteBeforeAfter">Your meetings should be about an hour long to allow time to discuss any 'gaps'. Make clear you do not have unlimited time; it is the responsibility of the claimant to use your time well.</blockquote>
        </div>
      </section>

      <section  v-intersection.once="onIntersection" :class="visibleClassSeven">
        <div class="section-hero sec-four"></div>
        <div class="container-section" id="DeferOrAward">
          <DeferOrAward />
        </div>  
      </section>  

      <section style="margin:0;">
        <div class="container-quote-banner">
        </div>
      </section>

  </div>
  <Footer />
</template>

<script>
import Hero from '../components/Hero.vue'
import Footer from '../components/Footer.vue'
import SuitableForRoute from '@/components/sections/SuitableForRoute.vue'
import HowRecognisedViaDialogue from '@/components/sections/HowRecognisedViaDialogue.vue'
import MentorDuties from '@/components/sections/MentorDuties.vue'
import DeferOrAward from '@/components/sections/DeferOrAward.vue'
import { scroll } from 'quasar'
import { ref } from '@vue/reactivity'
import { computed } from '@vue/runtime-core'

export default {
  components: { Hero, SuitableForRoute, HowRecognisedViaDialogue, MentorDuties, DeferOrAward, Footer },

  setup() {

    const colourChange = () => {
      const red = document.querySelectorAll('.container-section')
      red.forEach(i => i.style.backgroundColor = 'red')
    }
    
    const { getScrollTarget } = scroll

        const visible = ref(true)
        const visibleTwo = ref(true)
        const visibleThree = ref(true)

    const onIntersection = (entry) => {
        const mediaQuery = window.matchMedia('(min-width: 900px)')
        mediaQuery.matches ? visible.value = entry.isIntersecting : visible.value = true 
    }

    const onIntersectionTwo = (entry) => {
        const mediaQuery = window.matchMedia('(min-width: 900px)')
        mediaQuery.matches ? visibleTwo.value = entry.isIntersecting : visibleTwo.value = true 
    }

    const onIntersectionThree = (entry) => {
        const mediaQuery = window.matchMedia('(min-width: 900px)')
        mediaQuery.matches ? visibleThree.value = entry.isIntersecting : visibleThree.value = true 
    }

    const visibleClassFive = computed(() => { 
          if(visible.value) {
                return 'show-five'
          } else {
                return 'hide-five'
          }
    })

    const visibleClassSix = computed(() => { 
          if(visibleTwo.value) {
                return 'show-five'
          } else {
                return 'hide-five'
          }
    })
    const visibleClassSeven = computed(() => { 
          if(visibleThree.value) {
                return 'show-five'
          } else {
                return 'hide-five'
          }
    })

    return { 
      colourChange, 
      visibleClassFive, 
      onIntersection, 
      onIntersectionTwo, 
      onIntersectionTwo, 
      onIntersectionThree, 
      visibleClassSeven,
      getScrollTarget, 
      visibleTwo,
      visibleClassSix 
      }
  }
}
</script>

<style lang="scss" scoped>

.section-hero {
  background-position: center;
  height: 70vh;
  width: 100%;
  overflow: hidden;
  border-radius: 2rem  2rem 0 0;
  z-index: 999;
  position: relative;
}

 .sec-one {
    background-image: url('https://images.unsplash.com/photo-1472740378865-80aab8e73251?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2340&q=80');
     background-size: cover; 
    background-position: bottom;
  }

.sec-two {
    background-image: url('https://images.unsplash.com/photo-1573497620053-ea5300f94f21?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2340&q=80');
     background-size: cover; 
  }

.sec-three {
    background-image: url('https://images.unsplash.com/photo-1512238972088-8acb84db0771?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=3270&q=80');

     background-size: cover; 
  }

.sec-four {
    background-image: url('https://images.unsplash.com/photo-1614036417651-efe5912149d8?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2419&q=80');

     background-size: cover; 
  }

</style>